import { Component } from '@angular/core';
import { Manufacturer } from 'src/app/models/manufacturer.model';
import { ManufacturersService } from 'src/app/services/manufacturers/manufacturers.service';
import { ActivatedRoute, Router } from '@angular/router';
@Component({
  selector: 'app-manufacturers-list',
  templateUrl: './manufacturers-list.component.html',
  styleUrls: ['./manufacturers-list.component.scss']
})
export class ManufacturersListComponent {
  dtoptions: DataTables.Settings = {};
  manufacturers: Manufacturer[] = [];

  constructor(private manufacturersService: ManufacturersService,
    private router: Router) { }

    navigate(TId){
      console.log(TId);
      var id = btoa(TId.toString())
      this.router.navigate(['/component/manufacturers/edit/' + id]);
    }
    
  ngOnInit(): void {
    let loggedInuserRole = JSON.parse(atob(sessionStorage.getItem('currentUser')!));
    if (loggedInuserRole.role == 'Standard User' || loggedInuserRole.role == 'Internal User' || loggedInuserRole.role == 'Regional User') {
      this.logout();
    }
    console.log(loggedInuserRole);

    this.dtoptions = {
      pagingType: 'full_numbers',
    };
    this.manufacturersService.getAllManufacturers().subscribe({
      next: (manufacturers) => {
        this.manufacturers = manufacturers;
        
      },
      error: (response) => {
        console.log(response);
      },
    });
  }
  logout() {
    sessionStorage.clear();
    this.router.navigate(['login']);
  }
}
